<template>
  <div v-if="!loading" id="generali">
    <v-btn flat class="mb-2" @click="$emit('handleChangeView', { view: 'list' })">
      <v-icon class="mr-2">chevron_left</v-icon>{{ $t('Back') }}
    </v-btn>

    <component
      :is="currentView"
      v-model="input"
      :view="currentView"
      @handleSubmit="handleSubmit"
      @handleCancel="handleCancel"
      @handleChangeView="handleChangeView"
      @handleSaveDraft="handleSaveDraft"
      @handleShowSnackbar="handleShowSnackbar"
    />

    <v-snackbar v-model="showFailSnackbar" bottom right :timeout="3000" :color="'error'">
      Save unsuccessfully. Please try again
      <v-btn color="pink" flat fab dark small @click="showFailSnackbar = false">
        <v-icon small color="white">close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-snackbar v-model="showSuccessSnackbar" bottom right :timeout="3000" :color="'success'">
      Save successfully
      <v-btn color="pink" flat fab dark small @click="showSuccessSnackbar = false">
        <v-icon small color="white">close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import generaliApi from '@/api/generali'
import { handleResponse, handleApiError } from '@/api/util'

import General from './General.vue'
import Condition from './Condition.vue'
import Reward from './Reward.vue'
import Privilege from './Privilege.vue'
import Report from './Report.vue'
export default {
  components: {
    General,
    Condition,
    Reward,
    Privilege,
    Report
  },
  props: ['value'],
  data() {
    return {
      currentView: 'general',
      views: ['general', 'condition', 'privilege', 'reward', 'report'],
      input: {
        name: null,
        description: null,
        term_condition: null,
        game_type: null,
        cover: null,
        banner: null,
        background: null,
        start_campaign: null,
        start_campaign_date: null,
        start_campaign_time: null,
        end_campaign: null,
        end_campaign_date: null,
        end_campaign_time: null,
        time_to_play: null,
        time_to_play_type: null,
        is_limit: null,
        limits: null,
        notify_message: null,
        congratulation_message: null,
        failure_message: null,
        codes: []
      },
      loading: true,
      showFailSnackbar: false,
      showSuccessSnackbar: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.loading = true
    if (this.value) {
      this.input = { ...this.input, ...this.value }
    }
    this.loading = false
  },
  methods: {
    handleShowSnackbar(payload) {
      if (payload == true) {
        this.showSuccessSnackbar = true
      } else if (payload == false) {
        this.showFailSnackbar = false
      }
    },
    async handleSaveDraft() {
      const result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.$store.dispatch('loading')
      await this.saveCampaign()

      this.$store.dispatch('loading')
    },
    async handleSubmit({ step, view, data, isValidate = false }) {
      this.input = { ...this.input, ...data }

      this.$store.dispatch('loading')
      await this.saveCampaign()

      if (view) {
        this.currentView = view
      } else {
        switch (step) {
          case 1:
            this.currentView = 'general'
            break
          case 2:
            this.currentView = 'condition'
            break
          case 3:
            this.currentView = 'privilege'
            break
          case 4:
            this.currentView = 'reward'
            break
          case 5:
            this.currentView = 'report'
            break
          case 6:
            this.$store.dispatch('clear_loading')
            await this.$swal.fire({
              type: 'success',
              title: this.$t('Success')
            })
            this.$emit('handleChangeView', { view: 'list' })
          default:
            break
        }
      }

      this.$store.dispatch('clear_loading')
    },
    async handleCancel() {
      this.$emit('handleChangeView', { view: 'list' })
    },
    async saveCampaign() {
      let data = {
        ...this.input,
        page_id: this.selectedBot.pageid
      }
      try {
        let response = null
        if (this.input.id) {
          response = await generaliApi.putCampaign({
            config: {},
            data: {
              ...data,
              campaign_id: this.input.id,
              start_campaign: this.input.start_campaign_date
                ? this.input.start_campaign_date +
                  ' ' +
                  (this.input.start_campaign_time ? this.input.start_campaign_time : '00:00')
                : '',
              end_campaign: this.input.end_campaign_date
                ? this.input.end_campaign_date +
                  ' ' +
                  (this.input.end_campaign_time ? this.input.end_campaign_time : '23:59')
                : ''
            }
          })
        } else {
          response = await generaliApi.postCampaign({
            config: {},
            data: data
          })
        }
        await handleResponse(response)
        this.showSuccessSnackbar = true
        // campaign_id not found
        if (response.data.data) {
          this.input.id = response.data.data
        }
      } catch (error) {
        console.error(error)
        this.showFailSnackbar = true
        handleApiError(response)
      }
    },
    async handleChangeView(view) {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.currentView = view
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/Manage.vue